import { render, staticRenderFns } from "./dataPrivilegeStaff.vue?vue&type=template&id=419d8218&scoped=true"
import script from "./dataPrivilegeStaff.vue?vue&type=script&lang=js"
export * from "./dataPrivilegeStaff.vue?vue&type=script&lang=js"
import style0 from "./dataPrivilegeStaff.vue?vue&type=style&index=0&id=419d8218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419d8218",
  null
  
)

export default component.exports